module.exports = __webpack_public_path__ + "img/makarenko.066a5d29.jpg";